$(document).on("click", ".read-all", function () {
  if (!$(this).hasClass("active")) {
    $(this).addClass("active").html("Zwiń");
    $(".hidden-text").slideDown(400);
  } else {
    $(this).removeClass("active").html("Czytaj pełną treść");
    $(".hidden-text").slideUp(400);
  }
});
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    let $form = $("#contact-form");
    $form
      .find(".yl-zgoda_przetwarzanie_tresc, yl-zgoda_komunikacja_tresc")
      .remove();

    let $zgoda_przetwarzanie = $form.find(".yl-zgoda_przetwarzanie");
    let $zgoda_komunikacja = $form.find(".yl-zgoda_komunikacja");

    if ($form.find(".yl-zgoda_przetwarzanie")[0].checked) {
      let zgoda_przetwarzanie = $zgoda_przetwarzanie
        .parent()
        .find("span")
        .html();
      $form.append(
        `<input type="hidden" class="yl-zgoda_przetwarzanie_tresc" value="${zgoda_przetwarzanie}" />`
      );
    }
    if ($form.find(".yl-zgoda_komunikacja")[0].checked) {
      let zgoda_komunikacja = $zgoda_komunikacja.parent().find("span").html();
      $form.append(
        `<input type="hidden" class="yl-zgoda_komunikacja_tresc" value="${zgoda_komunikacja}" />`
      );
    }
    Monitor.TrackForm(
      "contact-form",
      $zgoda_komunikacja[0].checked ? 3 : 2,
      () => {
        window.location = "/podziekowanie";
      }
    );
  },
  false
);
